import { websocket } from '@/src/shared/lib/websocket'

export function websocketSendResumeTimer(): void {
  websocket.emitDefault('resumeTimer', undefined)
}
